import { render, staticRenderFns } from "./SbpMethod.vue?vue&type=template&id=28cfb40c&scoped=true"
import script from "./SbpMethod.vue?vue&type=script&lang=js"
export * from "./SbpMethod.vue?vue&type=script&lang=js"
import style0 from "./SbpMethod.vue?vue&type=style&index=0&id=28cfb40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cfb40c",
  null
  
)

export default component.exports